import { render, staticRenderFns } from "./reviewClosingOrders.vue?vue&type=template&id=434dae5f"
import script from "./reviewClosingOrders.vue?vue&type=script&lang=ts"
export * from "./reviewClosingOrders.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports